'use client';

import { Link, Typography } from '@coolblue-development/freddy';
import selectAvailableStoresPickupTrigger from '@coolblue-development/ga4-events/triggers/ItemCard/selectAvailableStoresPickupTrigger';
import { useAnalytics } from '@coolblue-development/next-analytics/client';
import { FilterPageProduct } from '@features/filter/types';
import { useTranslation } from '@i18n/useTranslation';
import { useState } from 'react';

import StoreStockModal from './StoreStockModal';

type Props = {
  product: FilterPageProduct;
  dateOverride?: string;
  children: number;
};

export default function StoreStockStatus({ product, dateOverride, children }: Props) {
  const { t } = useTranslation('webshop');
  const [isOpen, setIsOpen] = useState(() => false);
  const { trackEvent } = useAnalytics();

  const handleOpenAndTracking = () => {
    setIsOpen(true);
    trackEvent(selectAvailableStoresPickupTrigger());
  };

  return (
    <>
      <Link
        component='button'
        onClick={handleOpenAndTracking}
        sx={{ textAlign: 'left', '&:hover': { textDecoration: 'none' } }}
      >
        <Typography variant='body' color='interactiveSubtle'>
          {children > 1
            ? t('filterPage.storeStockStatusPlural', { storeCount: children })
            : t('filterPage.storeStockStatusSingular')}
        </Typography>
      </Link>
      <StoreStockModal
        open={isOpen}
        onClose={() => setIsOpen(false)}
        product={product}
        dateOverride={dateOverride}
      />
    </>
  );
}
